import { jsx as _jsx } from "react/jsx-runtime";
import { FullScreenEnter as FullScreenEnterIcon, FullScreenOut as FullScreenOutIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
export const FullScreenButton = /*#__PURE__*/ memo((param)=>{
    let { onFullScreenToggle, isFullScreen, iconText } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        onClick: onFullScreenToggle,
        className: "ml-0 md:ml-2",
        label: iconText,
        size: "large",
        children: isFullScreen ? /*#__PURE__*/ _jsx(FullScreenOutIcon, {
            className: "size-6"
        }) : /*#__PURE__*/ _jsx(FullScreenEnterIcon, {
            className: "size-6"
        })
    });
});
FullScreenButton.displayName = "FullScreenButton";
